import { render, staticRenderFns } from "./GraficoResultado.vue?vue&type=template&id=b9f6a6e0"
import script from "./GraficoResultado.vue?vue&type=script&lang=js"
export * from "./GraficoResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports